<template>
  <b-modal
    id="permissionsModal"
    v-model="modal.show"
    size="xl"
    title="Field Permission"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    :ok-only="true"
    :hide-header="true"
    body-class="permission-modal"
    @hidden="onHidden"
    @hide="beforeHide"
  >
    <Permissions
      v-if="modal.data"
      :modal-data="modalData"
    />
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../../core/components/ContentSpinner';
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import Permissions from '../Permissions';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');
export default {
  name: 'PermissionsModal',
  components: {InputWidget, ContentSpinner, Permissions},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      modal: state => state.permissionsModal,
      moduleData: state => state.permissionsModal.data,
      loading: state => state.permissionsModal.loading,
      permissionItemTypes: state => state.permissionItemTypes,
    }),
    modalData() {
      return {
        itemId: this.modal.data.fieldGuid,
        type: this.permissionItemTypes.field,
        data: this.modal.data,
      };
    },
  },
  methods: {
    ...mapActions(['hidePermissionsModal']),
    // onReset() {
    //   console.log('onReset-');
    // },
    beforeHide(e) {
      if (this.loading) {
        e.preventDefault();
        return false;
      }
    },
    onHidden() {
      this.form = {};
      this.hidePermissionsModal();
    },
  },
};
</script>

<style lang="scss">
.permission-modal {
  height: 750px;
}
</style>